export default __webpack_public_path__ + "static/media/README.908c6a01.md";